import React from "react";
import { View, ActivityIndicator, StyleSheet, ViewProps } from "react-native";

interface LoaderProps extends ViewProps {
  testID?: string;
}

const DLOLoader: React.FC<LoaderProps> = ({ testID, ...props }) => {
  return (
    <View testID={testID} style={styles.loaderContainer} {...props}>
      <ActivityIndicator size="large" color="#0066CC" />
    </View>
  );
};

const styles = StyleSheet.create({
  loaderContainer: {
    position: "absolute", // Full-screen overlay
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(251, 252, 254, 0.8)", // Semi-transparent background matching table color
    zIndex: 1000, // Ensure it appears above other components
    overflow: "hidden", // Prevent content from overflowing
  },
});

export default DLOLoader;
